const VERSION_URL = "/version.json";
const CHECK_INTERVAL_MS = 30000;
const VERSION_KEY = `${window.location.origin}${window.location.pathname}:frontendVersion`;

async function removeLegacyServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations
    .filter(registration => registration.scope.startsWith(window.location.origin))
    .map(registration => registration.unregister()));
}

async function checkVersion() {
  try {
    const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: "no-store",
      headers: { "Cache-Control": "no-cache" },
    });
    if (!response.ok) return;
    const { version } = await response.json();
    if (!version) return;
    const current = localStorage.getItem(VERSION_KEY);
    if (!current) {
      localStorage.setItem(VERSION_KEY, version);
    } else if (current !== version) {
      localStorage.setItem(VERSION_KEY, version);
      const url = new URL(window.location.href);
      url.searchParams.set("appVersion", version);
      window.location.replace(url.toString());
    }
  } catch (error) {
    // Una pérdida temporal de red no debe interrumpir la terminal.
  }
}

export function register() {
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", async () => {
    try { await removeLegacyServiceWorkers(); } finally {
      await checkVersion();
      window.setInterval(checkVersion, CHECK_INTERVAL_MS);
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) checkVersion();
      });
    }
  });
}

export function unregister() {
  return removeLegacyServiceWorkers();
}
